import urlParamsToObject from '../../utils/url/urlParamsToObject';
import removePrefixFromParams from '../../utils/url/removePrefixFromParams';
import updateValuesFromUrl from './_updateValuesFromUrl';
import * as URL from './_trackUrlParams';
import checkValue from './_checkValue';
import getDeviceFromIv from '../helpers/getDeviceFromIv';
import getDeviceByViewportWidth from '../helpers/getDeviceByViewportWidth';

/**
 * Names of the URL parameters.
 */
const URL_KEYS = ['aid', 'pubid', 'irpid', 'ircid', 'version', 'partner_sub_id', 'creative_id'].concat(URL.TRACK_CHANGES);


/**
 * Detect changes and update the `hc` object with values from the URL.
 *
 * @param  {Object} hcStorage - the `hc` object to be updated
 * @return {Boolean} if there were changes in the URL
 */
function checkChangesInUrl(hcStorage) {
  // gets all search parameters in the current URL
  const urlParameters = removePrefixFromParams(urlParamsToObject(), 'p.');
  let obj, prop, checked, param,
    hasChanges = false;

  URL_KEYS.forEach((key) => {
    prop = URL.MAP_KEYS[key] || key;
    obj = key.indexOf('utm_') === 0
      ? hcStorage.utm
      : hcStorage;

    // get the param from url does not matter if is in lowerCase or UpperCase
    param = urlParameters[key] ||
      urlParameters[key.toLowerCase()] ||
      urlParameters[key.toUpperCase()];
    // check if value from url is different from the one stored in localStorage
    checked = checkValue(obj[prop], param);

    if (checked.changed) {
      if (URL.TRACK_CHANGES.indexOf(key) > -1) {
        hasChanges = true;
      }

      if (checked.value && key === 'iv') {
        getDeviceFromIv(checked.value, hcStorage);
      }
    }

    obj[prop] = checked.value;
  });

  updateValuesFromUrl(urlParameters, hcStorage);

  if (!hcStorage.Device) {
    getDeviceByViewportWidth(hcStorage);
  }

  return hasChanges;
}

export default checkChangesInUrl;
